import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export type CxOptions = ClassValue[];

const cx = (...inputs: CxOptions) => twMerge(clsx(...inputs));

export default cx;
